CheckoutV2.PaymentV2.ModalChangeCard = function(checkout) {
    var changeCardModal = this;

    this.$modal = $('#changeCreditCardModal');

    this.currentPayment = null;
    this.shouldOpenAddCardModal = false;

    this.cardChangedCallback = function() {};

    this._init = function() {
        changeCardModal._listen();
    };

    this._listen = function() {
        // Listener for the change card submit button.
        changeCardModal.$modal.find('.js-change-credit-card-btn').on('click', function(e){
            var $item = changeCardModal.$modal.find('.js-credit-card-list input[type=radio]:checked');
            changeCardModal._getCards().forEach(function(card) {
                if(card.id === $item.val()){
                    changeCardModal.cardChangedCallback(card);
                }
            });
            changeCardModal.$modal.modal('hide');
        });

        //Modal jockeying for add cc
        //When the change modal closes, open add card if we clicked on it
        changeCardModal.$modal.on('hidden.bs.modal', function(e) {
            if(changeCardModal.shouldOpenAddCardModal) {
                changeCardModal.shouldOpenAddCardModal = false;
                checkout.payment.addNewCardModal.setCardAddedCallback(changeCardModal._onCardAdded);
                checkout.payment.addNewCardModal.setModalHiddenCallback(changeCardModal._onAddCardModalHidden);
                checkout.payment.addNewCardModal.show();
            }
        });
    };

    this._onCardAdded = function(card) {
        checkout.payment.addNewCard(card);
        changeCardModal.render();
    };

    this._onAddCardModalHidden = function() {
        changeCardModal.show();
    };

    this.render = function() {
        changeCardModal.$modal.find('.js-credit-card-list').html(
            Jemplate.process('includes/partials/payment/creditCardList.html', {
                current_card: changeCardModal._getCurrentCardId(),
                card_list: changeCardModal._getCards(),
                list_type: 'change'
            })
        );
        changeCardModal.$modal.find('.js-credit-card-list .card-address[data-toggle="popover"]').popover();

        changeCardModal.$modal.find('.js-add-credit-card').on('click', function(e) {
            e.preventDefault();
            changeCardModal.shouldOpenAddCardModal = true;
            changeCardModal.hide();
        });
    };

    this.show = function() {
        changeCardModal.$modal.modal('show');
    };

    this.hide = function() {
        changeCardModal.$modal.modal('hide');
    };

    this.setCurrentCard = function(card) {
        changeCardModal.currentPayment = card;
    };

    this.setCardChangedCallback = function(callback) {
        changeCardModal.cardChangedCallback = callback;
    };

    this._getCurrentCardId = function() {
        return changeCardModal.currentPayment.id;
    };

    this._getCards = function() {
        var cards = [];

        // Grab stored payments from session
        checkout.session.get('storedPayments').forEach(function(card) {
            if (!card.method.match(/creditcard/)) 
                return;
            var payment = checkout.payment.models.paymentMethodFromStoredCard(card, checkout.cart.totals.values.total);
            cards.push(payment);
        });

        // Also add any cards added through the add card modal
        checkout.payment.getAddedCards().forEach(function(card) {
            cards.push(card);
        });

        return cards;
    };

    this._init();
};
